<template>
    <div >
        <header class="bg-gray-100 text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 flex flex-col md:flex-row-reverse" style="max-width: 1800px">
                <div class="md:w-72 mb-12 md:mb-0 md:ml-8 lg:ml-12">
                    <img src="https://insync.software/mobile-img/logo.svg" class="h-12">
                    <div class="mt-4">
                        <p class="font-semibold mb-1">Hambro Roofing Limited</p>
                        <p>Unit 2, 6-10 Lamson Road Rainham Essex RM13 9YY</p>
                        <p><a href="tel:01708803930">01708 803 930</a></p>
                        <p><a href="http://www.hambroroofing.com">www.hambroroofing.com</a></p>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-8">
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Date:</h2>
                            <p class="mt-1 text-gray-500">{{ moment(rams.date).format('d/m/Y') }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Principle Contractor:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.principleContractor }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Site Address:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.siteAddress }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Location of Works:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.locationOfWorks }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Contract Manager:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.contractManager }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Contract Reference:</h2>
                            <p class="mt-1 text-gray-500">{{ rams.contractReference }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="bg-white text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 pb-16 lg:pb-16 flex flex-col-reverse lg:flex-row-reverse"
                 style="max-width: 1800px">
                <div class="lg:w-72 mb-12 lg:mb-0 lg:ml-12 ">
                    <div class="space-y-8 sticky top-4">
                        <div class="hidden lg:block" v-if="this.rams.attendees[0].signature">
                            <div class="text-center" v>Signed:</div>
                            <img v-if="this.rams.attendees[0].signature" :src="this.rams.attendees[0].signature"
                                 style="width:100%; margin: 5px">
                        </div>
                        <div v-else>
                            <h2 class="font-semibold text-lg text-gray-700">Next Step</h2>
                            <p class="text-sm mt-1.5">Please acknowledge this RAMS by signing.</p>
                            <p class="text-xs mt-2 text-gray-400">* This will open a signature box form to complete</p>
                            <div @click="addSignature"
                                 class="mt-6 flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white hover:text-white bg-gray-700 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer">
                                <i class="fa fa-signature mr-2"></i>
                                Sign this RAMS
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="text-5xl font-semibold text-gray-900">{{ rams.title }}</div>
                    <div class="mb-8 text-gray-500"><span class="font-semibold">Reference {{
                            rams.contractReference
                        }}</span> • {{ rams.package }}
                    </div>
                    <div class="text-gray-700">
                        <template v-for="item in rams.paragraphs">
                            <template>
                                <div class="flex mt-5">
                                    <div class="w-16 h-16 flex-shrink-0 p-0 mb-1 mr-1.5" v-if="item.iconClass">
                                        <div
                                            class="h-full w-full border border-gray-300 rounded-xl flex items-center align-middle">
                                <span class="text-gray-500 w-full text-center text-3xl"
                                      :class="item.iconClass"></span>
                                        </div>
                                    </div>
                                    <div>
                                        <h3 class="font-semibold text-gray-700">{{ item.title }}</h3>
                                        <p class="mt-1 whitespace-pre-wrap">{{ item.content }}</p>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <div class="text-3xl font-semibold text-gray-900 mt-4">Health Risks</div>
                    <div class="text-gray-700">
                        <template v-for="field in rams.healthRisks">
                            <h3 class="font-semibold mt-3 text-gray-700 mb-1.5">{{ field.hazard }}</h3>
                            <div class="flex items-start mb-1">
                                <div class="w-20 text-right text-gray-400 text-sm pt-1 min-h-[58px]">Risk:</div>
                                <div
                                    class="flex-1 mx-1 px-2 whitespace-pre-wrap border border-gray-300 rounded min-h-[58px]"
                                    v-text="field.hazardRisk"
                                ></div>
                                <div class="w-40 flex-shrink-0">
                                    <div
                                        class="flex border border-gray-300 rounded px-2 py-1 min-h-[58px]">
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-400">Without Controls</div>
                                            <div class="text-xs text-gray-600 pl-1">
                                                <div>Likelihood: <span class="text-gray-600"
                                                                       v-text="field.harmWithoutControls.likelihoodOfHarm?field.harmWithoutControls.likelihoodOfHarm:'?'"></span>
                                                </div>
                                                <div>Severity: <span class="text-gray-600"
                                                                     v-text="field.harmWithoutControls.severityOfHarm?field.harmWithoutControls.severityOfHarm:'?'"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                                v-text="field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm"
                                                :style="'background: '+getColor(field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-start mb-1">
                                <div class="w-20 flex-shrink-0 text-right text-gray-400 text-sm pt-1 min-h-[58px]">
                                    Controls:
                                </div>
                                <div
                                    class="flex-1 mx-1 px-2 whitespace-pre-wrap border border-gray-300 rounded min-h-[58px]"
                                    v-text="field.controls"
                                ></div>
                                <div class="w-40 flex-shrink-0">
                                    <div
                                        class="flex border border-gray-300 rounded px-2 py-1 min-h-[58px]">
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-400">With Controls</div>
                                            <div class="text-xs text-gray-600 pl-1">
                                                <div>Likelihood: <span class="text-gray-600"
                                                                       v-text="field.harmWithControls.likelihoodOfHarm?field.harmWithControls.likelihoodOfHarm:'?'"></span>
                                                </div>
                                                <div>Severity: <span class="text-gray-600"
                                                                     v-text="field.harmWithControls.severityOfHarm?field.harmWithControls.severityOfHarm:'?'"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                                v-text="field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm"
                                                :style="'background: '+getColor(field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="text-3xl font-semibold text-gray-900 mt-4">Safety Risks</div>
                    <div class="text-gray-700">
                        <template v-for="field in rams.safetyRisks">
                            <h3 class="font-semibold mt-3 text-gray-700 mb-1.5">{{ field.hazard }}</h3>
                            <div class="flex items-start mb-1">
                                <div class="w-20 text-right text-gray-400 text-sm pt-1 min-h-[58px]">Risk:</div>
                                <div
                                    class="flex-1 mx-1 px-2 whitespace-pre-wrap border border-gray-300 rounded min-h-[58px]"
                                    v-text="field.hazardRisk"
                                ></div>
                                <div class="w-40 flex-shrink-0">
                                    <div
                                        class="flex border border-gray-300 rounded px-2 py-1 min-h-[58px]">
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-400">Without Controls</div>
                                            <div class="text-xs text-gray-600 pl-1">
                                                <div>Likelihood: <span class="text-gray-600"
                                                                       v-text="field.harmWithoutControls.likelihoodOfHarm?field.harmWithoutControls.likelihoodOfHarm:'?'"></span>
                                                </div>
                                                <div>Severity: <span class="text-gray-600"
                                                                     v-text="field.harmWithoutControls.severityOfHarm?field.harmWithoutControls.severityOfHarm:'?'"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                                v-text="field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm"
                                                :style="'background: '+getColor(field.harmWithoutControls.likelihoodOfHarm * field.harmWithoutControls.severityOfHarm)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-start mb-1">
                                <div class="w-20 flex-shrink-0 text-right text-gray-400 text-sm pt-1 min-h-[58px]">
                                    Controls:
                                </div>
                                <div
                                    class="flex-1 mx-1 px-2 whitespace-pre-wrap border border-gray-300 rounded min-h-[58px]"
                                    v-text="field.controls"
                                ></div>
                                <div class="w-40 flex-shrink-0">
                                    <div
                                        class="flex border border-gray-300 rounded px-2 py-1 min-h-[58px]">
                                        <div class="flex-1">
                                            <div class="text-xs text-gray-400">With Controls</div>
                                            <div class="text-xs text-gray-600 pl-1">
                                                <div>Likelihood: <span class="text-gray-600"
                                                                       v-text="field.harmWithControls.likelihoodOfHarm?field.harmWithControls.likelihoodOfHarm:'?'"></span>
                                                </div>
                                                <div>Severity: <span class="text-gray-600"
                                                                     v-text="field.harmWithControls.severityOfHarm?field.harmWithControls.severityOfHarm:'?'"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                class="rounded-full w-10 h-10 bg-green-300 border-gray-200 mt-1.5 pt-2 text-center text-white"
                                                v-text="field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm"
                                                :style="'background: '+getColor(field.harmWithControls.likelihoodOfHarm * field.harmWithControls.severityOfHarm)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div v-if="this.rams.attendees[0].signature" class="lg:hidden block mt-4">
                    <div class="text-left">Signed:</div>
                    <img v-if="this.rams.attendees[0].signature" :src="this.rams.attendees[0].signature"
                         style="width:100%; margin: 5px; max-width: 350px">
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import UiContainer from "../../../ui/UiContainer.vue";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiDropdown from "../../../ui/UiDropdown.vue";
import UiButtonNew from "../../../ui/UiButtonNew.vue";
import UiDataGrid from "../../../ui/UiDataGrid.vue";
import UiDataGridItem from "../../../ui/UiDataGridItem.vue";
import UiHeader from "../../../ui/UiHeader.vue";
import Heading from "../../../ui/Heading.vue";
import {RAMS} from '@models'
import moment from "moment";

export default {
    components: {
        Heading,
        UiHeader,
        UiDataGridItem,
        UiDataGrid,
        UiButtonNew, UiDropdown, UiDropdownItem, UiContainer, AutoresizableTextarea
    },
    props: {
        rams: Object,
        name: String,
        attendeeId: String,
    },
    computed: {},
    data() {
        return {
            moment
        }
    },
    methods: {
        getColor(num) {
            return RAMS.getColor(num);
        },
        addSignature() {
            this.$modals.sign({
                title: `Sign as "${this.name}"`,
                button: 'Confirmed',
                handle: async (data) => {
                    await Http.post(window.location.href, {signature: data.signature})
                    window.location.reload()
                }
            })
        },
    },
    async mounted() {
    }

}
</script>
